import { __rest } from "tslib";
import React from 'react';
import SectionComponent from "../Section/Section";
import WidgetComponent from "../Widget/Widget";
export var LayoutComponent = function LayoutComponent(_a) {
  var sections = _a.sections,
    omittedCxeWidget = _a.omittedCxeWidget,
    omittedCxeSection = _a.omittedCxeSection,
    WIDGETS_MAPPER = _a.WIDGETS_MAPPER,
    WIDGETS_MAPPER_V2 = _a.WIDGETS_MAPPER_V2,
    rest = __rest(_a, ["sections", "omittedCxeWidget", "omittedCxeSection", "WIDGETS_MAPPER", "WIDGETS_MAPPER_V2"]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, sections.map(function (section, index) {
    var widgets = section.widgets,
      name = section.name,
      metadata = section.metadata;
    var widgetStyle = metadata && metadata.widgetStyle || {};
    if (omittedCxeSection === null || omittedCxeSection === void 0 ? void 0 : omittedCxeSection.includes(name)) {
      return null;
    }
    return /*#__PURE__*/React.createElement(SectionComponent, Object.assign({}, section, {
      key: "".concat(name, "_").concat(index)
    }), /*#__PURE__*/React.createElement("div", {
      style: widgetStyle
    }, widgets.map(function (widget, index) {
      var _a;
      var name = widget.name;
      if (!(omittedCxeWidget === null || omittedCxeWidget === void 0 ? void 0 : omittedCxeWidget.includes(name))) {
        return /*#__PURE__*/React.createElement(WidgetComponent, Object.assign({
          widget: widget,
          WIDGETS_MAPPER: WIDGETS_MAPPER,
          WIDGETS_MAPPER_V2: WIDGETS_MAPPER_V2,
          sectionTitlekey: ((_a = section.title) === null || _a === void 0 ? void 0 : _a.text) ? section.title.text : '',
          key: "".concat(name, "_").concat(index)
        }, rest));
      }
      return null;
    })));
  }));
};
export default LayoutComponent;